import { Link } from 'react-router-dom';
import { siteConfig } from '../config';

export function HomePage() {
  return (
    <>
      <section className="hero container">
        <div className="hero__grid">
          <div className="hero__content">
            <p className="eyebrow">Web development · UI · launch support</p>
            <h1 className="hero__title">
              Your startup deserves a presence customers can{' '}
              <span className="hero__accent">trust — and use</span>.
            </h1>
            <p className="hero__lede">{siteConfig.tagline}</p>
            <div className="hero__actions">
              <Link className="btn btn--outline" to="/contact">
                Get in touch
              </Link>
              <Link className="btn btn--outline" to="/services">
                See what I can build
              </Link>
            </div>
            <ul className="hero__chips" aria-label="Highlights">
              <li>Idea to Internet</li>
              <li>Responsive layouts</li>
              <li>Clear contact flows</li>
              <li>Fast and user-friendly</li>
              <li>Launch Ready Build</li>
            </ul>
          </div>
          <div className="hero__visual">
            <img
              src="https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=1200&q=90"
              alt="Laptop showing code and web page layout for web development"
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </>
  );
}
